// "Tasks count as overdue from" (Activity Status screen): the backend's app_settings.task_overdue_from_date.
export const HINT = 'Tasks without an end date that are dated before this day never turn Overdue or send overdue emails.'
